import React from "react";
import Modal from "react-modal";
import { twMerge } from "tailwind-merge";
import { Icon } from "./Icon";

type ModalProps = {
  isOpen: boolean;
  onDismiss?: () => void;
  className?: string;
  style?: React.CSSProperties;
};

export const ReactModal: React.FC<ModalProps> = ({ children, isOpen, onDismiss, className, style }) => {
  const handleDismiss = onDismiss ? onDismiss : undefined

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={handleDismiss}
      className={twMerge(`absolute bg-matBlack border-card top-1/2 left-1/2 right-auto bottom-auto mr-0 transform -translate-x-1/2 -translate-y-1/2 max-w-[620px] w-[580px] max-h-[94vh] overflow-visible rounded outline-none p-10 ${className}`)}
      overlayClassName="fixed inset-0 bg-thinBlack z-50"
    >
      <div className="static overflow-y-scroll max-h-[90vh]">
        {handleDismiss && (
          <div className="absolute top-2 right-4 hover:cursor-pointer text-white" onClick={handleDismiss}>
            <Icon name="times" size="sm" />
          </div>
        )}
        {children}
      </div>
    </Modal>
  );
};

